// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeProfileUpdateBody = {
  firstName?: string | null;
  lastName?: string | null;
  birthday?: string | null;
  phone?: string | null;
  timezone?: string | null;
  isDiscoverable?: boolean | null;
  isPoolListVisible?: boolean | null;
  onboardingStep?:
    | "username"
    | "details"
    | "signInMethods"
    | "photo"
    | "sports"
    | "leagues"
    | "done"
    | null;
};

export type typeProfileUpdateOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    profile: {
      accountId: string;
      username: string;
      displayName: string;
      firstName?: string | null;
      lastName?: string | null;
      birthday?: string | null;
      phone?: string | null;
      photoUrl?: string | null;
      timezone: string;
      isDiscoverable: boolean;
      isPoolListVisible: boolean;
      followedSportIds: string[];
      followedLeagueIds: string[];
      favoriteTeamIds: string[];
      onboardingStep:
        | "username"
        | "details"
        | "signInMethods"
        | "photo"
        | "sports"
        | "leagues"
        | "done";
      isOnboardingComplete: boolean;
      usernameChangedAt?: string | null;
      usernameChangeCount: number;
      createdAt: string;
      usernameChangeAvailableAt?: string | null;
    };
  };
};

export type typeProfileUpdateOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeProfileUpdateOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeProfileUpdateOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaProfileUpdateBody = {
  type: "object",
  properties: {
    firstName: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    lastName: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    birthday: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    phone: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    timezone: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    isDiscoverable: { oneOf: [{ type: "boolean" }, { enum: [null] }] },
    isPoolListVisible: { oneOf: [{ type: "boolean" }, { enum: [null] }] },
    onboardingStep: {
      oneOf: [
        {
          type: "string",
          enum: [
            "username",
            "details",
            "signInMethods",
            "photo",
            "sports",
            "leagues",
            "done",
          ],
        },
        { enum: [null] },
      ],
    },
  },
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createProfileUpdate(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaProfileUpdateBody);
  }

  return async function postProfileUpdate(
    payload: typeProfileUpdateBody,
  ): Promise<typeProfileUpdateOutput200 | typeProfileUpdateOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postProfileUpdate" failed before calling the network. #a397e80eb6d0`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#a397e80eb6d0" },
        },
        data: null,
      } as typeProfileUpdateOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/profile/update`,
      httpMethod: "POST",
      options,
    })) as typeProfileUpdateOutput200 | typeProfileUpdateOutput400;
  };
}
